import { Component, ViewChild , Output, EventEmitter, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import swal from 'sweetalert2';
import { ApidataService } from '../apidata.service';
import {
  environment,
  GINConstants,
} from '../../environments/environments';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';

declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;

@Component({
  selector: 'app-upload-file-free-tools',
  standalone: true,
  imports: [CommonModule, IconsFreeToolsComponent],
  templateUrl: './upload-file-free-tools.component.html',
  styleUrl: './upload-file-free-tools.component.css'
})
export class UploadFileFreeToolsComponent {
 @Output() uploadStarted = new EventEmitter<void>();
  @Output() uploadFinished = new EventEmitter<void>();
  developerKey = 'AIzaSyDG1HJnwaQxH3eba59D-dB7a31N9PPMhBA';
  clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  scope = ['profile', 'email', 'https://www.googleapis.com/auth/drive'].join(
    ' '
  );
  pickerApiLoaded = false;
  isUploadDivVisible: boolean = true;
  menuafterresponse: boolean = false;
  word_count;
  char_count;
  words_list = [];
  showUploadLoader = false;
  profile_id = '';
  isFirstExecution: boolean = true;
  chunks_id = [];
  get_chunk_text = [];
  server_chunks_text;
  dataListing: any[] = [];
  dataListingFinal: any[] = [];
  successAlert;
  errorAlerts;
  error: boolean = false;
  success: boolean = false;
  loaderAlert: boolean = false;
  constructor(private apirequest: ApidataService, private ngZone: NgZone) {
    this.profile_id = localStorage.getItem('profile_id');

    if (!this.profile_id) {
      this.profile_id = '1';
    }
  }

  gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
    $('#UpFileModal').modal('show');
  }

  onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport: boolean = false;
  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      localStorage.setItem('file_uploaded', 'true');
                      $('#mm').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt;

                      setTimeout(() => {
                        $('#mm').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;

                      localStorage.setItem('file_uploaded', 'true');
                      $('#mm').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt;

                      setTimeout(() => {
                        $('#mm').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      localStorage.setItem('file_uploaded', 'true');
                      $('#mm').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt;

                      setTimeout(() => {
                        $('#mm').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }


  openDropboxChooser(): void {
    

    const options = {
      success: (files: any[]) => {
        const file = files[0];
        const fileType = this.getFileType(file.name);

        if (['docx', 'pdf', 'txt'].includes(fileType)) {
          // Simulate upload
          this.uploadFileToServer(file.link, fileType);
        } else {
          console.warn('Unsupported file type');
        }
      },
      cancel: () => {
        // Emit finished if user cancels
        this.ngZone.run(() => this.uploadFinished.emit());
      },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };

    Dropbox.choose(options);
  }

  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.ngZone.run(() => this.uploadStarted.emit());
    this.word_count = 0;
    this.char_count = 0;

    this.menuafterresponse = false;
    this.loaderAlert =  true;

    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = { file_type: fileType, file_path: fileLink };
    this.apirequest.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      localStorage.setItem('file_uploaded', 'true');
      $('#mm').html(
        receivedData['RetCnt']
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&amp;/g, /&/g)
          .replace(/&gt;/g, '>')
          .replace(/&lt;/g, '<')
          .replace(/&quot;/g, /"/g)
          .replace(/\n/g, '<br>')
      );
      this.getContent('', receivedData['RetCnt']);
      this.loaderAlert =  false;
      this.ngZone.run(() => this.uploadFinished.emit());
    });
 
  
  }
  public getContent(event, text) {
    this.char_count = $('#mm').text().length;
    this.words_list = $('#mm').text().trim().split(' ');
    this.word_count = this.words_list.length;
  }
  @ViewChild('fileInput') fileInput;
  @ViewChild('fileInputs') fileInputs;

  uploadFileSaveRedirect(event): void {
    $('#UpFileModal').modal({ backdrop: 'static', keyboard: false });

    // console.log('object')

    const files: FileList = this.fileInput.nativeElement.files;
    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      this.showAlert('File should be less than 5 MB', '');

      swal({
        background: '#FFFFFF',
        title: 'Error',
        html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 310px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="display: flex; align-items: center;padding:10px ">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                File should be less than 5 MB
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-4 butn-alert">Ok</button>
          </div>
        </div>
      `,
        showConfirmButton: false,
        width: '300px',
        timer: 4000,
      });

      setTimeout(() => {
        const okButton = document.getElementById('swal-ok-button');
        if (okButton) {
          okButton.addEventListener('click', () => {
            swal.close();
          });
        }
      }, 0);


    } else {
      this.ngZone.run(() => this.uploadStarted.emit());
      let input = event.target;
      this.menuafterresponse = false;

      this.char_count = 0;
      this.loaderAlert =  true;

      this.apirequest.uploadfilefrombrowser(files).subscribe(
        (data) => {
          localStorage.setItem('file_uploaded', 'true');
          let receivedData = data;
          $('#mm').html(
            receivedData['RetCnt']
              .replace(/&quot;/g, '"')
              .replace(/&#x27;/g, "'")
              .replace(/&amp;/g, /&/g)
              .replace(/&gt;/g, '>')
              .replace(/&lt;/g, '<')
              .replace(/&quot;/g, /"/g)
              .replace(/\n/g, '<br>')
          );
          this.getContent('', receivedData['RetCnt']);

          this.char_count = $('#mm').text().length;
          this.word_count = $('#mm').text().split(/\s+/).length;

          this.fileInput.nativeElement.value = '';
          this.ngZone.run(() => this.uploadFinished.emit());
        },
        (error) => {
          this.showAlert(
            'Unable to proceed with a password protected file',
            ''
          );
        }
      );
    }
  }

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }
}




